import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/employee-daily-timescans", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const orgChartStructure = (Option = {}) => {
    return httpClient
        .get("/api/employee-daily-timescans/org-chart-structures", Option)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default { get, orgChartStructure };
